// extracted by mini-css-extract-plugin
export var arrow = "_2o-6";
export var changeItem = "_2o-3";
export var changesHeader = "_2o-1";
export var changesList = "_2o-2";
export var container = "_2o-0";
export var pathLabel = "_2o-4";
export var value = "_2o-7";
export var valuesContainer = "_2o-5";